export interface PasswordValidationRules {
  minLength: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
}

export interface PasswordValidation {
  isValid: boolean;
  score: number;
  rules: PasswordValidationRules;
  errors: string[];
}

export function validatePasswordStrength(password: string): PasswordValidation {
  const rules: PasswordValidationRules = {
    minLength: password.length >= 8,
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
  };

  const score = Object.values(rules).filter(Boolean).length;
  const isValid = Object.values(rules).every(Boolean);
  const errors = getPasswordErrors(password, rules);

  return {
    isValid,
    score,
    rules,
    errors,
  };
}

function getPasswordErrors(password: string, rules: PasswordValidationRules): string[] {
  const errors: string[] = [];

  if (!rules.minLength) {
    errors.push('Le mot de passe doit contenir au moins 8 caractères');
  }
  if (!rules.hasUpperCase) {
    errors.push('Le mot de passe doit contenir au moins une lettre majuscule');
  }
  if (!rules.hasLowerCase) {
    errors.push('Le mot de passe doit contenir au moins une lettre minuscule');
  }
  if (!rules.hasNumber) {
    errors.push('Le mot de passe doit contenir au moins un chiffre');
  }
  if (!rules.hasSpecialChar) {
    errors.push('Le mot de passe doit contenir au moins un caractère spécial (!@#$%^&*...)');
  }

  return errors;
}

export function getPasswordStrengthLabel(score: number): {
  label: string;
  color: string;
  bgColor: string;
} {
  if (score <= 2) {
    return {
      label: 'Faible',
      color: 'text-red-500',
      bgColor: 'bg-red-500',
    };
  } else if (score === 3) {
    return {
      label: 'Moyen',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500',
    };
  } else if (score === 4) {
    return {
      label: 'Bon',
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-500',
    };
  } else {
    return {
      label: 'Fort',
      color: 'text-green-500',
      bgColor: 'bg-green-500',
    };
  }
}
